import { jsonDelete, jsonGet, jsonPost, jsonPut, jsonPatch } from "../api";

export const fetchBrands = async () => await jsonGet("brands");

export const fetchBrandById = async (brandId) =>
  await jsonGet(`brands/${brandId}`);

export const createBrand = async (brandData) =>
  await jsonPost("brands", brandData);

export const updateBrand = async (brandId, brandData) =>
  await jsonPut(`brands/${brandId}`, brandData);

export const pingSiteRefresh = async (brandId) =>
  await jsonPost(`brands/${brandId}/site-refresh`, { all: true });

export const detectBrandDetails = async (brandId) =>
  await jsonPost(`brands/${brandId}/detect-details`);

export const deleteBrand = async (brandId) =>
  await jsonDelete(`brands/${brandId}`);

export const detectBrands = async (dto) =>
  await jsonPost("brands/autodetect", dto);

export const activateBrand = async (brandId) =>
  await jsonPost(`brands/${brandId}/activate`);

export const importPositioning = async (brandId, rawText) =>
  await jsonPost(`brands/${brandId}/positioning-import`, { rawText });

export const suggestCategories = async (brandId) =>
  await jsonPost(`brands/${brandId}/categories/suggest`);

export const fetchBrandAnalyticsTimeline = async (brandId, params = {}) => {
  const searchParams = new URLSearchParams();

  if (params.industry) searchParams.append("industry", params.industry);
  if (params.aspect) searchParams.append("aspect", params.aspect);
  if (params.llmProvider)
    searchParams.append("llmProvider", params.llmProvider);
  if (params.type) searchParams.append("type", params.type);
  if (params.startDate)
    searchParams.append("startDate", params.startDate.toISOString());
  if (params.endDate)
    searchParams.append("endDate", params.endDate.toISOString());

  const queryString = searchParams.toString();
  const url = queryString
    ? `brands/${brandId}/awareness/analytics/timeline?${queryString}`
    : `brands/${brandId}/awareness/analytics/timeline`;

  return await jsonGet(url);
};
